<template>
  <div class="enterprise-content">
    <div class="right">
      <div class="title">企业库存分布</div>
      <div class="enterprise">
        <div class="enterprise-total">
          商品种类(种)：
          <span>{{warehouseInfoAll.categoryCount}}</span>
        </div>
        <div class="enterprise-total">
          库存总重(吨)：
          <span>{{warehouseInfoAll.calcWeight}}</span>
        </div>
        <div class="enterprise-total">
          货区(个)：
          <span>{{warehouseInfoAll.positionCount}}</span>
        </div>
        <div class="enterprise-total">
          库存总数：
          <span>{{warehouseInfoAll.calcNum}}</span>
        </div>
      </div>
      <div class="warehouse">
        <el-dropdown class="mydropdown" style="color: #fff; cursor: pointer;z-index: 999999;" trigger="click" @command="handleDropmenu">
          <span class="el-dropdown-link"> {{ command.storehouseName  }}<i class="el-icon-caret-bottom el-icon--right"></i> </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item v-for="(item, index) in dropdownList" :command="item" :key="index">{{ item.storehouseName }}</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <div class="warehouse-box">
          <div class="warehouse-box-item">
            商品种类(种)：
            <span>{{warehouseInfo.categoryCount}}</span>
          </div>
          <div class="warehouse-box-item">
            库存总重(吨)：
            <span>{{warehouseInfo.calcWeight}}</span>
          </div>
          <div class="warehouse-box-item">
            货区(个)：
            <span>{{warehouseInfo.positionCount}}</span>
          </div>
          <div class="warehouse-box-item">
            库存总数：
            <span>{{warehouseInfo.calcNum}}</span>
          </div>
        </div>
      </div>
    </div>

    <div class="left">
      <div class="title">出入库货值统计</div>
      <div class="left-total">
        当前库存货值(万)：
        <span>{{priceInfo.calcPrice}}</span>
      </div>
      <div class="left-chart" id="pieCharts"></div>
    </div>
  </div>
</template>

<script>
	import {
			queryEnterpriseStorehouseList,
			queryEnterpriseInventoryStatistics,
			queryEnterpriseInventoryByPositionIdStatistics,
			queryEnterpriseInventoryPriceStatistics
		} from "@/api/wms/warehouse.js";
export default {
  props: {
    superviseId: {
      typeof: String,
      default: ''	
    },
	loanYearQuery: {
	  typeof: String,
	  default: ''	
	}
  },
  components: {},
  data() {
    return {
      dropdownList: [],
      command: {storehouseName:'未知',positionId:null},
	  warehouseInfoAll:{
		  categoryCount:0,
		  calcWeight:0,
		  positionCount:0,
		  calcNum:0,
		  calcPrice:0,
	  },
	  warehouseInfo:{
	  		  categoryCount:0,
	  		  calcWeight:0,
	  		  positionCount:0,
	  		  calcNum:0,
	  		  calcPrice:0,
	  },
	  priceInfo:{
		  calcPrice:0,
		  list:[]
	  }

    }
  },
  watch:{
	  loanYearQuery(newVal, oldVal){
		  // this.getEnterpriseInventoryStatistics()
		  // this.getEnterpriseStorehouseList()
		  this.getEnterpriseInventoryPriceStatistics()
      //this.getEnterpriseInventoryByPositionIdStatistics()

    },
	  superviseId(newVal, oldVal){
			this.getEnterpriseInventoryStatistics()
			this.getEnterpriseStorehouseList()
			this.getEnterpriseInventoryPriceStatistics()
      this.getEnterpriseInventoryByPositionIdStatistics()

    }
  },
  created() {},
  mounted() {
	  console.log('初始化子组件')
	  this.getEnterpriseInventoryStatistics()
	  this.getEnterpriseStorehouseList()
	  this.getEnterpriseInventoryPriceStatistics()
    this.getEnterpriseInventoryByPositionIdStatistics()

  },

  methods: {
	  getEnterpriseInventoryPriceStatistics(){
		queryEnterpriseInventoryPriceStatistics({"superviseId":this.superviseId,"loanYearQuery":this.loanYearQuery}).then(res=>{
			console.log(res)
			if(res.status==200&&res.data.code==200&&res.data.result){
				this.priceInfo=res.data.result
				this.$nextTick(() => {
					let outPriceList=[]
					let inPriceList=[]
					this.priceInfo.list.forEach(item=>{
						outPriceList.push(item.outPrice)
						inPriceList.push(item.inPrice)
					})
				  this.initChart('pieCharts',outPriceList,inPriceList)
				})
			}
		})  
	  },
	  getEnterpriseStorehouseList(){
		  queryEnterpriseStorehouseList({"superviseId":this.superviseId,"loanYearQuery":this.loanYearQuery}).then(res=>{
			  console.log(res)
			  if(res.status==200&&res.data.code==200&&res.data.result&&res.data.result.length>0){
			  	this.dropdownList=res.data.result
				this.command=this.dropdownList[0]
				this.getEnterpriseInventoryByPositionIdStatistics(this.dropdownList[0].positionId)
			  }
		  })
	  },
	  
	  getEnterpriseInventoryStatistics(){
		queryEnterpriseInventoryStatistics({"superviseId":this.superviseId,"loanYearQuery":this.loanYearQuery}).then(res=>{
			console.log(res)
			if(res.status==200&&res.data.code==200&&res.data.result){
				this.warehouseInfoAll=res.data.result
				
			}
		})  
	  },
	  getEnterpriseInventoryByPositionIdStatistics(positionId){
		queryEnterpriseInventoryByPositionIdStatistics({"superviseId":this.superviseId,"loanYearQuery":this.loanYearQuery,"positionId":positionId}).then(res=>{
			console.log(res)
			if(res.status==200&&res.data.code==200&&res.data.result){
				this.warehouseInfo=res.data.result
				
			}
		})  
	  },
    handleDropmenu(command) {
      console.log(command)
	  this.getEnterpriseInventoryByPositionIdStatistics(command.positionId)
      this.command = command
    },
    initChart(id,outPriceList,inPriceList) {
      this.chart?.clear()
      this.chart = this.$echarts.init(document.getElementById(id))
      var option = {
        grid: {
          left: 40,
          right: 30,
          top: 50,
          bottom: 20,
        },
        legend: {
          color: ['#EFAB44', '#85BC3C'],
          data: [
            {
              name: '出库',
              textStyle: {
                color: '#EFAB44',
              },
            },
            {
              name: '入库',
              textStyle: {
                color: '#85BC3C',
              },
            },
          ],
          top: 10,
          right: 50,
          itemWidth: 10,
          itemHeight: 10,
          textStyle: {
            fontSize: '10px',
            color: 'rgba(255, 255, 255, 1)',
          },
        },
        calculable: true,
        tooltip: {
          trigger: 'axis',
          backgroundColor: 'rgba(255,255,255,0.8)',
          borderColor: '#292929',
          borderWidth: 1,
          textStyle: {
            color: '#EFAB44',
          },
          formatter: function (data) {
            console.log(data)
            let dom = ''
            data.forEach((item) => {
              dom += `<p>
                            ${item.seriesName}：
                            ${item.value} 万元
                    </p>`
            })
            return `<div>${dom}</div>`
          },
        },
        xAxis: [
          {
            type: 'category',
            data: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
            axisLine: {
              lineStyle: {
                width: 1,
                color: 'rgba(255, 255, 255, 0.5)',
              },
            },
            axisLine: {
              show: true, // Y轴线
              symbol: ['none', 'arrow'],
              symbolSize: [6, 6],
              lineStyle: {
                color: 'rgba(255,255,255,0.15)',
                width: '1',
                type: 'solid',
              },
            },
            axisLabel: {
              color: '#FFFFFF',
            },
            axisTick: {
              show: false,
            },
          },
        ],
        yAxis: [
          {
            name: '万元',
            show: true,
            type: 'value',
            symbol: ['none', 'arrow'],
            nameTextStyle: {
              color: '#FFFFFF',
              padding: [3, 10, 0, 0],
            },
            axisLine: {
              show: true,
              symbol: ['none', 'arrow'],
              symbolSize: [6, 6],
              lineStyle: {
                color: 'rgba(255,255,255,0.15)',
                width: '1',
                type: 'solid',
              },
            },
            axisLabel: {
              color: '#FFFFFF',
            },
            splitLine: {
              lineStyle: {
                type: 'dashed',
                color: 'rgba(255,255,255,0.05)',
              },
            },
          },
          {
            name: '',
            show: false,
            type: 'value',
            nameTextStyle: {
              color: '#FFFFFF',
              padding: [3, 10, 0, 0],
            },
            axisLine: {
              lineStyle: {
                color: 'rgba(255,255,255,0.15)',
              },
            },
            axisLabel: {
              color: '#FFFFFF',
            },
            splitLine: {
              lineStyle: {
                type: 'dashed',
                color: 'rgba(255,255,255,0.05)',
              },
            },
          },
          //
        ],
        series: [
          {
            name: '出库',
            type: 'bar',
            data: outPriceList,
            barWidth: '10',
            // yAxisIndex: 0,
            itemStyle: {
              color: '#EFAB44',
            },
          },
          {
            name: '入库',
            type: 'bar',
            data: inPriceList,
            barWidth: '10',
            // yAxisIndex: 1,
            itemStyle: {
              color: '#85BC3C',
            },
          },
        ],
      }

      this.chart?.clear()
      this.chart.setOption(option)
      window.addEventListener('resize', () => {
        this.chart.resize()
      })
    },
  },
}
</script>

<style scoped lang="scss">
.enterprise-content {
  width: 100%;
  height: 4.5rem;
  display: flex;
  justify-content: space-between;
  .title {
    width: 100%;
    height: 1rem;
    // background: orange;
    font-size: 14px;
    font-family: Source Han Sans, Source Han Sans;
    font-weight: 700;
    color: #ffffff;
    display: flex;
    align-items: center;
  }
  .right {
    width: 4.25rem;
    height: 100%;
    // background-color: aquamarine;
    .enterprise {
      width: 100%;
      height: 0.75rem;
      //   background: blueviolet;
      padding: 0 0.125rem;
      box-sizing: border-box;
      display: flex;
      flex-wrap: wrap;
      align-content: space-between;
      &-total {
        width: 50%;
        height: 0.225rem;
        // background-color: brown;
        font-size: 0.15rem;
        font-family: Source Han Sans, Source Han Sans;
        font-weight: 400;
        color: #ffffff;
        span {
          font-size: 0.25rem;
          font-family: DIN, DIN;
          font-weight: 700;
          color: #efab44;
        }
      }
    }
    .warehouse {
      width: 100%;
      height: 2.3rem;
      //   background-color: burlywood;
      margin-top: 0.4rem;
      padding: 0 0.125rem;
      box-sizing: border-box;
      padding-top: 0.375rem;
      background: linear-gradient(154deg, rgba(255, 255, 255, 0.01) 0%, rgba(255, 255, 255, 0.06) 57%, rgba(255, 255, 255, 0.01) 100%);
      &-box {
        width: 100%;
        height: 0.825rem;
        // background-color: aqua;
        margin-top: 0.4rem;
        display: flex;
        flex-flow: wrap;
        align-content: space-between;
        &-item {
          width: 50%;
          height: 0.225rem;
          //   background-color: brown;
          font-size: 0.15rem;
          font-family: Source Han Sans, Source Han Sans;
          font-weight: 400;
          color: #ffffff;
          span {
            font-size: 0.25rem;
            font-family: DIN, DIN;
            font-weight: 700;
            color: #efab44;
          }
        }
      }
    }
  }
  .left {
    flex: 1;
    height: 100%;
    // background-color: antiquewhite;
    padding-left: 0.6rem;
    box-sizing: border-box;
    &-total {
      width: 100%;
      //   background-color: yellowgreen;
      font-size: 0.15rem;
      font-family: Source Han Sans, Source Han Sans;
      font-weight: 400;
      color: #ffffff;
      span {
        font-size: 0.25rem;
        font-family: DIN, DIN;
        font-weight: 700;
        color: #efab44;
      }
    }
    &-chart {
      width: 100%;
      height: 2.7rem;
      //   background-color: cadetblue;
      margin-top: 0.5rem;
    }
  }
}
</style>
